import { Component, Input } from '@angular/core';
import { ProgressBarModule } from 'primeng/progressbar';

@Component({
  selector: 'app-progressbar',
  imports: [ProgressBarModule],
  template: `
    <p-progressbar
      [mode]="indeterminate ? 'indeterminate' : 'determinate'"
      [style]="{ height: '6px', width: width }"
      [value]="value"
    />
  `,
  styles: ``,
})
export class ProgressbarComponent {
  /**
   * A number between 0 and 100.
   */
  @Input()
  value = 0;

  @Input()
  indeterminate = true;

  @Input()
  width = '200px';
}
